import { createSetWorkDataAction } from "../actions/dataActions";
import { useGetAndSet } from "./useGetAndSet";

export const useWorkData = (params, dataFresh) => {
  return useGetAndSet("work", params, createSetWorkDataAction, dataFresh);
};
